export const FuncCallPromise = (f, doThat, params = [], scope = null) => {
    return new Promise((resolve, reject) => {
        if (!doThat) {
            resolve(null);
            return;
        }

        if (typeof f !== 'function') {
            reject('FuncCallPromise first parameter is not a function.');
        }

        f.apply(scope, params);
        resolve(doThat);
    });
};
